export type InvertObj<T extends Record<string, string>> = {
  [K in T[keyof T]]: keyof T;
};

/**
 * A better-typed version of lodash's invert. Returns an object mapping
 * `obj`'s values to `obj`'s keys.
 *
 * @param obj the object to be inverted
 * @returns an inverted copy of obj
 */
export function invert<T extends Record<string, string>>(obj: T): InvertObj<T> {
  const res: Partial<InvertObj<T>> = {};

  for (const key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      const value = obj[key];
      res[value as keyof InvertObj<T>] = key;
    }
  }

  return res as InvertObj<T>;
}
